import { makeStyles } from "@material-ui/core/styles";
import { RemittanceStatusEnum } from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  () => ({
    remittanceStatusLabel: {
      fontWeight: 600,
      overflow: "hidden",
      paddingLeft: "11px",
      paddingRight: "11px",
      textOverflow: "ellipsis"
    },

    statusDefaultLabel: {
      backgroundColor: "#C6DDFF"
    },
    statusForConfirmationLabel: {
      border: "solid",
      color: "#ffa600"
    },
    statusRemittedLabel: {
      backgroundColor: "#A4EA9A"
    },
    statusToRemitLabel: {
      backgroundColor: "#FFEBC6"
    },

    statusWrapper: {
      borderRadius: "25px",
      display: "inline",
      margin: "2px",
      paddingBottom: "5px",
      paddingTop: "5px",
      position: "relative",
      whiteSpace: "nowrap"
    }
  }),
  { name: "RemittanceRunnerStatusBadge" }
);

export interface RemittanceRunnerStatusBadgeProps {
  status: RemittanceStatusEnum;
}

const RemittanceRunnerStatusBadge: React.FC<RemittanceRunnerStatusBadgeProps> = props => {
  const { status } = props;
  const classes = useStyles(props);

  let statusLabel = "";
  switch (status) {
    case RemittanceStatusEnum.TO_REMIT:
      statusLabel = "To Remit";
      break;
    case RemittanceStatusEnum.FOR_BANK_CONFIRMATION:
      statusLabel = "For Confirmation";
      break;
    case RemittanceStatusEnum.REMITTED:
      statusLabel = "Remitted";
      break;
    default:
      break;
  }

  const checkStatus = () => {
    switch (status) {
      case RemittanceStatusEnum.TO_REMIT:
        return (
          <div
            className={classNames(
              classes.statusToRemitLabel,
              classes.statusWrapper
            )}
          >
            <span className={`${classes.statusToRemitLabel}`}></span>
            <span className={classes.remittanceStatusLabel}>{statusLabel}</span>
          </div>
        );
      case RemittanceStatusEnum.FOR_BANK_CONFIRMATION:
        return (
          <div
            className={classNames(
              classes.statusForConfirmationLabel,
              classes.statusWrapper
            )}
          >
            <span className={`${classes.statusToRemitLabel}`}></span>
            <span className={classes.remittanceStatusLabel}>{statusLabel}</span>
          </div>
        );
      case RemittanceStatusEnum.REMITTED:
        return (
          <div
            className={classNames(
              classes.statusRemittedLabel,
              classes.statusWrapper
            )}
          >
            <span className={`${classes.statusRemittedLabel}`}></span>
            <span className={classes.remittanceStatusLabel}>{statusLabel}</span>
          </div>
        );
      default:
        return (
          <div
            className={classNames(
              classes.statusDefaultLabel,
              classes.statusWrapper
            )}
          >
            <span className={`${classes.statusDefaultLabel}`}></span>
            <span className={classes.remittanceStatusLabel}>{statusLabel}</span>
          </div>
        );
    }
  };

  return checkStatus();
};

export default RemittanceRunnerStatusBadge;
